import React, { useEffect, useRef, useState } from "react"
import { message, Space, Tooltip, Tag } from "antd"

import TableCustom from "src/components/Table/CustomTable"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import CB1 from "src/components/Modal/CB1"
import IconBase from "src/components/IconBase"
import PopupAction from "src/components/PopupAction"
import Notice from "src/components/Notice"
import dayjs from "dayjs"

import STORAGE, { getStorage } from "src/lib/storage"
import WarehouseService from "src/services/WarehouseService"
import ViewDetailModal from "../Modal/ViewDetailModal"
import ModalCreate from "../Modal/ModalCreate"
import ModalCreateDeliveryBill from "../../Proposal/Modal/ModalDetailProposal"
import FilterIn from "./FilterIn"
import ModalActiveSimDetail from "../Modal/ModalActiveSimDetail"
import { set } from "lodash"

const MODAL_ACTION = {
  view: { type: "view", title: "Xem thông tin khách hàng" },
  edit: { type: "edit", title: "Chỉnh sửa thông tin khách hàng" },
}

function WarehouseEntry({
  type,
  setFilter,
  filter,
  permissions,
  setExcelKeyword,
}) {
  const [dataSource, setDataSource] = useState([])
  const [dataSelected, setDataSelected] = useState([])
  const [isModalAction, setIsModalAction] = useState({})
  const [searchTerm, setSearchTerm] = useState("")
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [isViewModalOpen, setIsViewModalOpen] = useState(false)
  const [selectedRecord, setSelectedRecord] = useState(null)
  const [isUpdateModalOpen, setIsUpdateModalOpen] = useState(false)
  const [sorter, setSorter] = useState({})
  const [summary, setSummary] = useState({})
  const expiryWarningDays = 7
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const [onlyView, setOnlyView] = useState(false)
  const [subscriptionModalVisible, setSubscriptionModalVisible] =
    useState(false)
  const [selectedSubscription, setSelectedSubscription] = useState(null)
  const [keyword, setKeyword] = useState("")

  // Effect chính để gọi API khi có thay đổi về pagination, filter, keyword, type, sorter
  useEffect(() => {
    if (type) {
      fetchSimWarehouse(
        pagination.current,
        pagination.pageSize,
        type,
        filter,
        keyword,
        sorter,
      )
    }
  }, [type, pagination.current, pagination.pageSize, filter, keyword, sorter])

  // Effect riêng biệt để reset pagination khi filter hoặc keyword thay đổi
  useEffect(() => {
    // Chỉ reset pagination nếu hiện tại không phải trang 1
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    }
  }, [filter, keyword, type])

  // Cập nhật handleTableChange để lưu sorter
  const handleTableChange = (paginationTable, _, sorter) => {
    const sortField = sorter.field
    const sortOrder = sorter.order

    let sortPayload = {}

    if (sortField === "activation_deadline") {
      sortPayload.deadline = sortOrder === "ascend" ? "asc" : "desc"
    }

    // Cập nhật pagination và sorter
    setPagination(prev => ({
      ...prev,
      current: paginationTable.current,
      pageSize: paginationTable.pageSize,
    }))
    setSorter(sortPayload)
  }

  const onCloseModalAction = () => {
    setIsModalAction({})
  }

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setDataSelected(selectedRows)
    },
  }

  const handleAction = (actionType, record) => {
    switch (actionType) {
      case "view":
        setSelectedRecord(record.ID)
        setIsViewModalOpen(true)
        break
      case "edit":
        setSelectedRecord(record.ID)
        setIsUpdateModalOpen(true)
        break
      case "delete":
        // Xử lý xoá
        break
      default:
        break
    }
  }

  // Cột bảng phiếu nhập kho
  const columns = [
    {
      title: "Số lô nhập",
      dataIndex: "approval",
      key: "approval",
      align: "center",
      render: approval => approval?.batch_number || "",
    },
    {
      title: "Nhà cung cấp",
      dataIndex: "supplier_id",
      key: "supplier_id",
      align: "center",
    },
    {
      title: "Nhà mạng",
      dataIndex: "carrier_id",
      key: "carrier_id",
      align: "center",
    },
    {
      title: "Vùng phủ sóng",
      dataIndex: "coverage_areas",
      render: areas => {
        if (!Array.isArray(areas) || areas.length === 0) return "-"

        // Lấy danh sách title quốc gia
        const countryTitles = areas
          .map(area => area.country?.title)
          .filter(Boolean) // loại bỏ undefined/null

        // Xoá trùng
        const uniqueTitles = [...new Set(countryTitles)]

        // Nối chuỗi
        return uniqueTitles.join(", ")
      },
      align: "center",
    },
    // {
    //   title: "Quốc gia",
    //   dataIndex: "country",
    //   key: "country",
    //   align: "center",
    // },
    {
      title: "Seri SIM",
      dataIndex: "serial_number",
      key: "serial_number",
      align: "center",
    },
    {
      title: "Số thuê bao",
      dataIndex: "phone_number",
      key: "phone_number",
      align: "center",
    },
    {
      title: "Loại SIM",
      dataIndex: "type_sim",
      key: "type_sim",
      align: "center",
      render: value => {
        if (value === "esim") return "E-SIM"
        if (value === "usim") return "Sim vật lý"
        return value
      },
    },
    {
      title: "Loại hình SIM",
      dataIndex: "sim_type",
      key: "sim_type",
      align: "center",
      render: value => {
        if (value === "2") return "Travel"
        if (value === "1") return "IoT"
        return value
      },
    },
    {
      title: "Local/Roaming",
      dataIndex: "scope",
      align: "center",
      render: value => {
        if (value === "1") return "Local"
        if (value === "2") return "Roaming"
        return value
      },
    },
    {
      title: "Loại thanh toán",
      dataIndex: "payment_type",
      align: "center",
      render: value => {
        if (value === "1") return "Trả trước"
        if (value === "2") return "Trả sau"
        return value
      },
    },
    {
      title: "Thời gian phải kích hoạt",
      dataIndex: "activation_deadline",
      align: "center",
      sorter: true,
      render: (_, record) => {
        if (!record.activation_deadline || !record.created_at) return "-"

        const created_at = dayjs(record.created_at)
        const activation_deadline = dayjs(record.activation_deadline)
        const now = dayjs()

        const totalDuration = activation_deadline.diff(
          created_at,
          "milliseconds",
        )
        const halfPoint = created_at.add(totalDuration / 2, "milliseconds")

        const isNearDeadline =
          record.status === "0" &&
          now.isAfter(halfPoint) &&
          now.isBefore(activation_deadline.add(1, "day"), "day")

        const isTodayDeadline =
          record.status === "0" && now.isSame(activation_deadline, "day")

        const isOverdue =
          record.status === "0" && now.isAfter(activation_deadline, "day")

        let color = "inherit"
        let fontWeight = "normal"
        let tooltipTitle = ""

        if (isOverdue) {
          color = "orange"
          fontWeight = "bold"
          tooltipTitle = "Đã quá hạn kích hoạt"
        } else if (isTodayDeadline) {
          color = "red"
          fontWeight = "bold"
          tooltipTitle = "Hôm nay là hạn cuối để kích hoạt"
        } else if (isNearDeadline) {
          color = "red"
          fontWeight = "bold"
          tooltipTitle = "Cảnh báo: gần đến thời hạn kích hoạt"
        }

        return (
          <Tooltip title={tooltipTitle}>
            <span style={{ color, fontWeight }}>
              {activation_deadline.format("DD/MM/YYYY")}
              {isTodayDeadline && " ❗"}
              {isNearDeadline && !isTodayDeadline && " 🚩"}
              {isOverdue && " ⛔"}
            </span>
          </Tooltip>
        )
      },
    },
    // {
    //   title: "Ngày kích hoạt",
    //   dataIndex: "sim_user",
    //   align: "center",
    //   render: sim_user => {
    //     const date = sim_user?.start_date
    //     return date ? dayjs(date).format("DD/MM/YYYY") : ""
    //   },
    // },
    // {
    //   title: "Ngày hết hạn",
    //   dataIndex: "sim_user",
    //   align: "center",
    //   render: sim_user => {
    //     const dateStr = sim_user?.end_date
    //     if (!dateStr) return ""

    //     const expiryDate = dayjs(dateStr)
    //     const now = dayjs()
    //     const diffDays = expiryDate.diff(now, "day")

    //     const isExpired = diffDays < 0
    //     const isNearExpiry = diffDays >= 0 && diffDays <= expiryWarningDays

    //     return (
    //       <Tooltip
    //         title={isExpired ? "Đã hết hạn" : isNearExpiry ? "Gần hết hạn" : ""}
    //       >
    //         <span
    //           style={{
    //             color: isExpired ? "red" : "inherit",
    //             fontWeight: isExpired ? "bold" : "normal",
    //             display: "inline-flex",
    //             alignItems: "center",
    //             gap: 6,
    //             cursor: "default",
    //           }}
    //         >
    //           {expiryDate.format("DD/MM/YYYY")}
    //           {isNearExpiry && !isExpired && (
    //             <span role="img" aria-label="Cảnh báo">
    //               🚩
    //             </span>
    //           )}
    //         </span>
    //       </Tooltip>
    //     )
    //   },
    // },
    {
      title: "Gói cước",
      dataIndex: "package",
      key: "package",
      align: "center",
    },
    // {
    //   title: "Trạng thái",
    //   dataIndex: "status",
    //   key: "status",
    //   align: "center",
    //   render: value => {
    //     let statusText = ""
    //     let statusColor = ""

    //     switch (value) {
    //       case "0":
    //         statusText = "Chưa kích hoạt"
    //         statusColor = "orange"
    //         break
    //       case "1":
    //         statusText = "Đã kích hoạt"
    //         statusColor = "green"
    //         break
    //       case "2":
    //         statusText = "Đã vô hiệu"
    //         statusColor = "red"
    //         break
    //       case "3":
    //         statusText = "Đã gia hạn"
    //         statusColor = "blue"
    //         break
    //       case "4":
    //         statusText = "Đã cấp lại"
    //         statusColor = "purple"
    //         break
    //       case "5":
    //         statusText = "Đã thu hồi"
    //         statusColor = "violet"
    //         break
    //       default:
    //         statusText = ""
    //         statusColor = "black"
    //         break
    //     }

    //     return (
    //       <span style={{ color: statusColor, fontWeight: "bold" }}>
    //         {statusText}
    //       </span>
    //     )
    //   },
    // },
    // {
    //   title: "Loại chiết khấu",
    //   dataIndex: "deployment_type",
    //   key: "deployment_type",
    //   align: "center",
    //   render: value => {
    //     if (value === "percent") return "Chiết khấu %"
    //     if (value === "fixed") return "Chiết khấu số tiền"
    //     return value
    //   },
    // },
    // {
    //   title: "Chiết khấu",
    //   dataIndex: "discount_value",
    //   key: "discount_value",
    //   align: "center",
    // },
    {
      title: "Người duyệt",
      dataIndex: "approval",
      key: "approval",
      align: "center",
      render: approval => approval?.approved?.fullname || "--",
    },
    {
      title: <Tooltip title={"Hành động"}>_</Tooltip>,
      dataIndex: "action",
      key: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => {
        return (
          <PopupAction>
            <div
              onClick={() => {
                handleAction("view", record)
              }}
            >
              <IconBase name="eye" />
              <span>Xem chi tiết</span>
            </div>
          </PopupAction>
        )
      },
    },
  ]

  const fetchSimWarehouse = async (
    page,
    per_page,
    type,
    filter,
    keyword,
    sort = {},
  ) => {
    setLoading(true)
    setExcelKeyword(keyword)
    try {
      const response = await WarehouseService.getListSimWarehouse({
        page: page,
        per_page: per_page,
        type,
        filter: {
          // over_50_percent_time: true,
          ...filter,
        },
        keyword,
        ...sort,
      })

      const warehouseIns = response?.success?.data || []
      const total = response?.success?.total || warehouseIns.length
      const perPage = response?.success?.per_page

      const dataSource = warehouseIns.map(item => ({
        ...item,
        unit_price: Number(item.unit_price || 0).toLocaleString(),
        country: item.country?.title || "",
        supplier_id: item.supplier?.name || "",
        carrier_id: item.carrier?.name || "",
        package: item.package?.name || "",
        discount_value: Number(item.discount_value).toLocaleString(),
        coverage_areas: item.carrier?.coverage_areas || [],
      }))

      setData(dataSource)
      setPagination(prev => ({
        ...prev,
        pageSize: perPage,
        total,
      }))
      setSummary({
        totalAccounts: total,
      })
    } catch (error) {
      console.error("Lỗi khi lấy danh sách phiếu xuất kho", error)
      message.error("Không thể lấy danh sách phiếu xuất kho")
    } finally {
      setLoading(false)
    }
  }

  const [shownError, setShownError] = useState(false)
  const hasPermission = permissions.includes("warehouse.sim")

  useEffect(() => {
    if (!hasPermission && !shownError) {
      message.error("Không có quyền truy cập")
      setShownError(true)
    }
  }, [hasPermission, shownError])

  if (!hasPermission) {
    return null
  }

  return (
    <div style={{ width: "100%" }}>
      <div style={{ minWidth: "100", marginBottom: 0, display: "flex" }}>
        {dataSelected.length > 0 ? (
          <ButtonCircle
            style={{ marginRight: "10px" }}
            title="Xóa hàng đã chọn"
            iconName="delete-outline"
            onClick={() =>
              CB1({
                title: `Bạn có chắc chắn muốn xoá <strong>${dataSelected.length}</strong> bản ghi không?`,
                icon: "trashRed",
                okText: "Đồng ý",
                onOk: async close => {
                  // Logic to delete selected rows
                  close()
                },
              })
            }
          />
        ) : null}
        <FilterIn
          filter={filter}
          setFilter={setFilter}
          setKeyword={setKeyword}
        />
      </div>
      <div style={{ display: "flex", flexDirection: "row", margin: "10px 0" }}>
        <div style={{ padding: "0 5px", color: "#007BFF" }}>
          <strong>Tổng số: {summary.totalAccounts}</strong>
        </div>
      </div>

      <TableCustom
        rowKey="ID"
        showPagination={true}
        isPrimary
        columns={columns}
        dataSource={data}
        loading={loading}
        onChange={handleTableChange}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            setPagination(prev => ({
              ...prev,
              current: page,
              pageSize: pageSize,
            }))
          },
        }}
        bordered
        scroll={{ x: "max-content" }}
        style={{ width: "100%", position: "relative" }}
      />

      {selectedSubscription && (
        <ModalActiveSimDetail
          record={selectedSubscription}
          open={subscriptionModalVisible}
          onClose={() => setSubscriptionModalVisible(false)}
        />
      )}

      {isViewModalOpen && (
        <ViewDetailModal
          open={isViewModalOpen}
          onClose={() => setIsViewModalOpen(false)}
          onOk={() => {
            setIsViewModalOpen(false)
          }}
          id={selectedRecord}
          onlyView={true}
        />
      )}

      {isUpdateModalOpen && (
        <ViewDetailModal
          open={isUpdateModalOpen}
          onClose={() => setIsUpdateModalOpen(false)}
          onOk={() => {
            setIsUpdateModalOpen(false)
          }}
          id={selectedRecord}
          onlyView={false}
        />
      )}
    </div>
  )
}

export default WarehouseEntry
